var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6033 30.6748C23.9547 29.7466 21.2109 29.6327 20.4 27.2V23.8C21.165 23.4209 23.3512 20.8165 23.5824 18.7816C23.7184 18.3005 23.8238 16.5801 23.8238 16.1925C23.8238 14.0692 23.7915 9.6798 25.1209 6.2441C24.6568 3.9355 23.4447 1.9907 20.8454 1.734C20.1501 0.5831 18.3685 0 16.0514 0C6.7847 0.1598 5.8378 6.5841 7.6976 13.9638C7.3372 14.1712 6.7422 14.8308 6.8918 16.0004C7.1706 18.1815 8.1158 18.734 8.7176 18.7799C8.9471 20.8165 11.135 23.4209 11.9 23.8V27.2C10.2 32.3 0 27.2 0 40.8H20.4C20.4 34.7684 23.783 32.1691 26.6033 30.6748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8008 40.7992C23.8008 32.2992 32.3008 33.9992 34.0008 29.3973V27.2298C27.8451 27.2298 26.1366 24.6951 26.1366 24.6951C29.353 22.0193 23.2704 3.39922 34.2218 3.39922C34.2218 3.39922 35.7008 1.69922 37.6116 1.69922C51.0008 1.69922 44.959 21.9173 48.4219 24.7597C48.4219 24.7597 46.9871 27.2077 40.8008 27.2077V29.3973C42.5008 33.9992 51.0008 32.2992 51.0008 40.7992H23.8008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParental);
export default __webpack_public_path__ + "static/media/Parental.1d9e138d5ba7d5dca1caaeac9cdeb750.svg";
export { ForwardRef as ReactComponent };